<template >
  <div >
    <div class="fromComponents" v-for="(item,index) of FronSY" :key="index">
      <div class="fromTitle">
        {{ item.title }}
        <div class="operation" @click="operation(index)">
          {{ item.operationFlag ? "收起" : "展开" }} <img src="../../../../../assets/channel/menu/menuDown.png" alt="" :class="[ item.operationFlag ? 'imgs' : 'img'  ]">
        </div>
      </div>
      <div class="redLine"></div>
      <transition name="sub-menu">
        <div class="from" v-show="item.operationFlag">
          <fromComm :FromArr="item.FromArr"></fromComm>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
import fromComm from './Commfrom/from-comm.vue'
export default {
  components: {
    fromComm
  },
  props: {
      FronSY: {
          type: Array
      }
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    operation(index) {
      this.FronSY[index].operationFlag = !this.FronSY[index].operationFlag
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.fromComponents {
  width: 890px;
  height: 100%;
  position: relative;
  margin: 0 auto;

  .from {
    border-bottom: 1px solid #ebedf0;
    width: 100%;
    padding-bottom: 32px;
    overflow: hidden;
  }

  .operation {
    display: inline;
    float: right;
    font-size: 14px;
    color: #424e66;
    cursor: pointer;
  }
  .img {
    vertical-align: middle;
    margin-left: 4px;
    transform: rotate(180deg);
    transition: all 0.3;
  }
  .imgs {
    vertical-align: middle;
    margin-left: 4px;
    transform: rotate(0deg);
    transition: all 0.3;
  }

  .fromTitle {
    width: 890px;
    height: 54px;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
    margin: 0 auto;
    color: #16181a;
    font-size: 16px;
    line-height: 54px;
    font-weight: 500;
  }

  .redLine {
    width: 120px;
    height: 3px;
    display: inline-block;
    background-color: #e71d43;
    position: relative;
    bottom: 12px;
  }
}
.site-menu-sub {
  padding: 0px;
}
.sub-menu-enter-active,
.sub-menu-leave-active {
  max-height: 500px; /* 这里70px为menu-one子菜单的高度 */
  transition: max-height 0.3s ease;
}
.sub-menu-enter,
.sub-menu-leave-to {
  max-height: 0;
}
</style>